import React, { useState, useEffect } from "react";
import { Layout } from "antd";
import { useThemeSwitcher } from "react-css-theme-switcher";
import { BrowserRouter as Router, useHistory, useLocation } from "react-router-dom";

import Headers from "../Header";
import Footers from "../Footer";
import Sidenav from "../Sidenav";
import SidenavRoutes from "../../routes/Sidenav";
import { StoreContextProvider } from "../../context";
import { canViewSection } from "../../helpers/permissions";

export default function MainContent() {
  const [collapsed, setCollapsed] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(false);
  const { switcher, status, themes } = useThemeSwitcher();

  useEffect(() => {
    const theme = localStorage.getItem("theme");
    setIsDarkMode(theme === "dark" ? true : false);

    // Apply theme to document root
    document.documentElement.setAttribute("data-theme", theme || "light");
  }, []);

  const toggleTheme = () => {
    const newTheme = isDarkMode ? "light" : "dark";
    setIsDarkMode(!isDarkMode);
    switcher({ theme: isDarkMode ? themes.light : themes.dark });
    localStorage.setItem("theme", newTheme);

    // Apply theme to document root
    document.documentElement.setAttribute("data-theme", newTheme);
  };

  // Avoid theme change flicker
  if (status === "loading") {
    return null;
  }

  return (
    <StoreContextProvider>
      <Layout>
        <Headers toggleTheme={toggleTheme} isDarkMode={isDarkMode} />
        <Layout className="lyt">
          <Router basename="/">
            <Sidenav onSideNavCollapse={(value) => setCollapsed(value)} />
            <SidenavRoutes contentWidth={collapsed ? 55 : 200} />
          </Router>
          <Footers />
        </Layout>
      </Layout>
    </StoreContextProvider>
  );
}
